import { Component } from '@angular/core';
import { SrOrganicLandingComponent } from '../sr-organic-landing/sr-organic-landing.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [SrOrganicLandingComponent],
  template: '<app-sr-organic-landing />',
})
export class HomeComponent {}
